<p-card class="wo-card" [ngClass]="{'multiday': workOrder.isMultiday, 'grayOverlay': shouldDisableWODrag}" (click)="dblclickHandler()">
  @if (workOrder) {
    <p-header class="container">
      <div class="wo-header row">
        <div class="zip-code col-6"
          [style.background]="(workOrder.address && workOrder.address.geoColor) ? workOrder.address.geoColor : ''"
          [style.color]="(workOrder.address && workOrder.address.textColor) ? workOrder.address.textColor : ''">
          {{workOrder.address?.zip}}
        </div>
        <div class="status col-6" (mouseenter)="datePanel01.toggle($event)" (mouseleave)="datePanel01.toggle($event)"
          [style.background]="(workOrder.mostUrgentPriorityLevel && workOrder.mostUrgentPriorityLevel.backgroundColor) ? workOrder.mostUrgentPriorityLevel.backgroundColor : ''"
          [style.color]="(workOrder.mostUrgentPriorityLevel && workOrder.mostUrgentPriorityLevel.textColor) ? workOrder.mostUrgentPriorityLevel.textColor : ''" style="overflow: hidden;">
          {{workOrder.mostUrgentPriorityLevel?.status}}
          <p-popover #datePanel01 [appendTo]="'body'">
            <div>
              {{workOrder.mostUrgentPriorityLevel?.status}}
            </div>
            @if (workOrder.completionStatus != 'Completed' && workOrder.completionStatus !='Unable to be Completed') {
              <div>
                @for (task of scheduledTasks; track task) {
                  <span>
                    @if (!task.wellnessTask.isGoBack) {
                      <div>
                        {{getDueDateDisplay(task.wellnessTask)}}
                      </div>
                    }
                    @if (task.wellnessTask.isGoBack) {
                      <div>
                        GO BACK
                      </div>
                    }
                  </span>
                }
              </div>
            }
          </p-popover>
        </div>
      </div>
    </p-header>
  }

  <div class="customer-name">
    <a class="blue-link" [routerLink]="" (click)="navigateToWorkOrder()">{{workOrder.quoteNumber}}</a> @if (workOrder.isMultiday) {
    <span>- Multiday</span>
    }@if (workOrder.completionStatus == 'Completed' || workOrder.completionStatus =='Unable to be Completed') {
    <i class="pi pi-check middle-this" pTooltip="Work Order is Complete"></i>
  }
  <br>
    {{customCustomerService.getCustomerFullName(workOrder.customer)}} @if (showMap) {
    <i class="fa fa-map-marked-alt" (click)="openMap()"></i>
    }<br />
    @if (hasCompanyWideNotes) {
      <i class="fa fa-sticky-note" (click)="op.toggle($event)"></i>
    }
    <p-popover #op [appendTo]="'body'">
      <app-customer-comment-view-only [customer]="workOrder.customer"></app-customer-comment-view-only>
    </p-popover>
  </div>

  <div class="equipment-type">
    {{ equipmentTypeDisplay }}
  </div>

  <div class="toggle-more-information">
    <div class="left" (click)="taskPanel.toggle($event)">
      {{scheduledTasksTotal}}/{{workOrder.workOrderWellnessTasks.length}}
      <p-popover #taskPanel appendTo="body">
        <div class="center bold">Wellness Tasks</div>
        @for (woWellnessTask of workOrder.workOrderWellnessTasks; track woWellnessTask) {
          <div>
            <span class="left">{{woWellnessTask.wellnessTask.name}}
              @if (woWellnessTask.wellnessTask.scheduleDateFrom) {
                <i class="pi pi-star middle" [pTooltip]="woWellnessTask.wellnessTask.scheduleDateFrom | date: 'shortDate'"
                ></i>
              }
            </span>
          </div>
        }
      </p-popover>
    </div>
    @if (isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          +
        </span>
      </div>
    }
    @if (!isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          -
        </span>
      </div>
    }
    <div [ngbCollapse]="isCollapsed" class="more-information">
      @if (!disableDrag) {
        <div [id]="'woTaskList-' + workOrder.id + '-' + bucket.id" cdkDropList [cdkDropListDisabled]="!canDrag"
          [cdkDropListData]="scheduledTasks" [cdkDropListConnectedTo]="dragAndDropService.bucketWOListIds"
          cdkDropListSortingDisabled="true">
          @for (woWellnessTask of scheduledTasks; track woWellnessTask) {
            <div class="inner-card" cdkDrag
              (cdkDragStarted)="dragStart(woWellnessTask, $event)" (cdkDragEnded)="taskDragEnd()"
              [cdkDragDisabled]="shouldDisableTaskDrag(woWellnessTask.wellnessTask)">
              <app-task-card [task]="woWellnessTask.wellnessTask" [isDisabled]="shouldDisableTaskDrag(woWellnessTask.wellnessTask)" [showPrice]="!workOrder.hidePrice || canSeeHiddenPrice"></app-task-card>
            </div>
          }
        </div>
      }
      <!-- This is for my-schedule page when tasks shouldn't be draggable -->
      @if (disableDrag) {
        <div>
          @for (woWellnessTask of scheduledTasks; track woWellnessTask) {
            <div class="inner-card">
              <app-task-card [task]="woWellnessTask.wellnessTask" [isDisabled]="shouldDisableTaskDrag(woWellnessTask.wellnessTask)" [showPrice]="!workOrder.hidePrice || canSeeHiddenPrice"></app-task-card>
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (workOrder) {
    <div class="card-footer">
      @if (workOrder.completionStatus) {
        <span>{{workOrder.completionStatus}}</span>
      }
      <hr style="padding: 0px; margin: 0px;"/>
      <span>@if (!workOrder.hidePrice || canSeeHiddenPrice) {
        <span>{{priceSummary | currency}} <i class="pi pi-circle-on"style="font-size: .5em;"></i></span>
      } {{hoursSummary}} {{unit}}</span>
    </div>
  }
</p-card>
